<template>
    <div v-if="modalOpened" class="fixed inset-0 w-full bg-black/30 z-[60]">
        <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
            <div class="w-[330px] overflow-hidden m-auto">
                <!-- actual modal -->
                <!-- <div v-if="modalType.status === 'Success'"
                    class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden" >
                    <div v-if="modalType.status == 'Success'"
                        class="w-full flex flex-col justify-center items-center gap-4 p-6">
                        <CheckTickIcon class="fill-success w-16 h-16"></CheckTickIcon>
                        <span class="PC_H2-R text-darkText text-center">เพิ่มข้อมูลสำเร็จ</span>
                        <button class="btn w-1/3 !font-normal" @click="closeModal">ปิด</button>
                    </div>
                    <div v-if="modalType.status == 'หากลบข้อมูลไปแล้ว จะไม่สามารถเรียกคืนข้อมูลได้ ต้องการลบหรือไม่'"
                        class="w-full flex flex-col justify-center items-center gap-4 p-6">
                        <TrashcanIcon class="fill-success w-16 h-16" />
                        <span class="PC_Body1 text-darkText text-center">หากลบข้อมูลไปแล้ว จะไม่สามารถเรียกคืนข้อมูลได้
                            ต้องการลบหรือไม่</span>
                        <div class="w-full flex justify-center items-center gap-2.5">
                            <button class="btn !bg-danger w-1/2 !font-normal" @click="closeModal">ลบ</button>
                            <button class="btn !bg-white w-1/2 !font-normal !text-darkText border border-soft-grey"
                                @click="closeModal">ยกเลิก</button>
                        </div>
                    </div>
                </div> -->
                <div v-if="modalType.status === 'success'"
                    class="w-[330px] h-fit rounded-[10px] bg-[#F2FCE9] overflow-hidden fixed z-50 top-[130px] right-[40px]">
                    <div class="pt-[12px] pb-[16px] px-[16px] w-[330px] h-fit flex flex-col">
                        <!-- เนื้อหา -->
                        <div class="flex items-start gap-2.5">
                            <CheckTickIcon class="w-[24px] h-[24px] mt-[2px]" circle-color="#95E648" tickColor="#FFF" />
                            <div>
                                <span class="block PC_H3-SB text-[#3B5C1C] font-semibold">
                                    {{ modalInfo.header || 'ดำเนินการสำเร็จ !' }}
                                </span>
                                <span class="block PC_Body-2R text-sm text-[#3B5C1C] mt-[2px]">
                                    {{ modalInfo.subHeader || 'ระบบได้ลบข้อมูล สำเร็จ' }}
                                </span>
                            </div>
                        </div>

                        <!-- ปุ่ม -->
                        <div class="text-right mt-auto pt-3 ">
                            <button v-if="modalInfo.deleteSuccessButton" class="btn-secondary w-1/3 !font-normal"
                                @click="closeAndGo">
                                {{ modalInfo.deleteSuccessButton || 'ปิดหน้าต่าง' }}
                            </button>
                            <button v-else class="btn-secondary w-1/3 !font-normal" @click="closeModal">
                                {{ modalInfo.closeButtonText || 'ปิดหน้าต่าง' }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="modalType.status === 'warning'"
                    class="w-[330px]  rounded-[10px] bg-[#FEFCE8] overflow-hidden z-[150]">
                    <div class="pt-[12px] pb-[16px] px-[16px] w-[330px]  flex flex-col">
                        <div class="flex items-start gap-2.5">
                            <div class="pt-[2px]">
                                <InfoIcon class="!text-warning w-[24px] h-[24px]" />
                            </div>
                            <div class="">
                                <span class="block PC_H3-SB text-yellow-700 font-semibold h-[35px]">คำเตือน !</span>
                                <span class="block PC_Body-2R text-sm text-yellow-700 whitespace-pre-line">
                                    {{ modalInfo.subHeader || "จะไม่สามารถเรียกคืนข้อมูลได้ ท่านต้องการลบข้อมูลหรือไม่"
                                    }}
                                </span>
                                <div v-if="fileldConfirm">
                                    <input type="text" placeholder="กรอกข้อความ" v-model="fileldConfirmData"
                                        class="h-[42px] text-[14px] border border-[#B7B2B5] rounded-[6px] w-full mt-[8px] p-[10px] bg-[#FFF] focus:outline-none focus:border-[0.5px] focus:border-[#1F1D1F]"></input>
                                </div>
                            </div>
                        </div>
                        <div class="text-right mt-auto pt-[8px] gap-[10px] pr-[10px] flex justify-end">
                            <button
                                class=" !text-[13px] bg-white rounded-[6px] border border-[#B7B2B5] py-2.5 text-nowrap hover:opacity-70 !font-normal w-[93px] h-[42px]"
                                @click="closeModal">
                                {{ modalInfo.closeButtonText || 'ปิด' }}
                            </button>
                            <button
                                class="btn-warning !font-normal min-w-[93px] !text-[13px] disabled:!bg-[#DFDCDD] disabled:!cursor-not-allowed disabled:!text-[#B7B2B5] disabled:border-none"
                                @click="confirmDelete" :disabled="fileldConfirm && !fileldConfirmData">
                                {{ modalInfo.submitButtonText || 'ลบข้อมูล' }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="modalType.status === 'error'"
                    class="mx-auto box-effect rounded-[10px] bg-[#FCE8E7] overflow-hidden z-150">
                    <div class=" w-[330px]  p-[16px] pt-[12px]">
                        <div class="flex">
                            <div class="pr-[10px] pt-[2px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"
                                    fill="none">
                                    <path
                                        d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20Z"
                                        fill="#EB5554" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M13.5358 6.46477C13.9264 6.85529 13.9264 7.48846 13.5358 7.87898L7.87898 13.5358C7.48846 13.9264 6.85529 13.9264 6.46477 13.5358C6.07424 13.1453 6.07424 12.5121 6.46477 12.1216L12.1216 6.46477C12.5121 6.07424 13.1453 6.07424 13.5358 6.46477Z"
                                        fill="#F7F9FD" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.46477 6.46477C6.85529 6.07424 7.48846 6.07424 7.87898 6.46477L13.5358 12.1216C13.9264 12.5121 13.9264 13.1453 13.5358 13.5358C13.1453 13.9264 12.5121 13.9264 12.1216 13.5358L6.46477 7.87898C6.07424 7.48846 6.07424 6.85529 6.46477 6.46477Z"
                                        fill="#F7F9FD" />
                                </svg>
                            </div>

                            <div>
                                <span class="block PC_H3-SB text-[#A33B3B]">
                                    {{ modalInfo.header || "เกิดความผิดพลาด !" }}
                                </span>
                                <span
                                    class="text-[#A33B3B] whitespace-pre-line font-kanit text-sm leading-[21px] font-normal">
                                    {{ modalInfo.subHeader || "โปรดตรวจสอบข้อมูลให้ถูกต้อง" }}
                                </span>
                            </div>
                        </div>
                        <div class="text-right mt-[8px]">
                            <button class="w-[93px] h-[42px] rounded-[6px] bg-[#FFF] s border border-[#B7B2B5]"
                                @click="closeModalNothing">
                                {{ modalInfo.closeButtonText || "ปิดหน้าต่าง" }}
                            </button>
                            <button v-if="modalInfo.submitButtonText"
                                class="ml-[10px] !bg-[#EB5554] text-[#FFF] btn-secondary w-1/3 !font-normal"
                                @click="closeModal">
                                {{ modalInfo.submitButtonText }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import CheckTickIcon from '../../assets/icons/checkTick.icon.vue';
import TrashcanIcon from '../../assets/icons/trashcan.icon.vue';
import InfoIcon from '../../assets/icons/info.icon.vue';

const props = defineProps({
    status: {
        type: String,
        default: ''
    },

})

const modalType = ref({
    status: props.status
});
const modalOpened = ref(false);
const fileldConfirm = ref(false)
const modalInfo = ref({
    header: '',
    subHeader: '',
    closeButtonText: '',
    submitButtonText: '',
    deleteSuccessButton: '',
    timeout: "",
});
const modalItem = ref("");
const fileldConfirmData = ref("")
let timeoutId = null;
const emit = defineEmits(["confirm", "closeAndGo", "tryAgain"]);

const openModal = (status, passedModalInfo, data) => {
    if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
    modalType.value.status = status;
    modalOpened.value = true
    modalInfo.value = passedModalInfo
    modalItem.value = data;
    document.body.style.overflow = 'hidden';
    fileldConfirm.value = passedModalInfo.fileldConfirm
    if (modalInfo.value.timeout) {
        timeoutId = setTimeout(() => {
            closeModal();
            timeoutId = null;
        }, modalInfo.value.timeout);
    }
}

const closeModal = () => {
    if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
    fileldConfirmData.value = ""
    emit("tryAgain");
    modalOpened.value = false
    document.body.style.overflow = 'auto';
}

const closeModalNothing = () => {
    if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
    fileldConfirmData.value = ""
    // emit("tryAgain");
    modalOpened.value = false
    document.body.style.overflow = 'auto';
}

const confirmDelete = () => {
    console.log('[child] will emit:', fileldConfirmData.value);
    emit("confirm", fileldConfirmData.value);
    //  emit("submit", modalItem.value); 


    //   if (!fileldConfirm.value) {
    //     emit("confirm");
    //   } else {
    //     emit("confirm", fileldConfirmData.value?.trim() || ""); 
    //   }
    closeModal();
    fileldConfirmData.value = ""
};

const closeAndGo = () => {
    emit("closeAndGo");
    closeModal()
}

onMounted(() => {
    // console.log(modalOpened.value)
    // console.log(props)
})
defineExpose({ openModal });
</script>
<style></style>